



























import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import {
    CurrentStepTitle,
    BoxHeading,
    ProgressFooter,
    SFSelect,
    SFRadio,
    SFInput,
    SFLoader
    } from '@/components'

const formNamespace = 'form';
const progressNamespace = 'progress';

@Component({
    components: {
        CurrentStepTitle,
        SFSelect,
        SFRadio,
        SFInput,
        SFLoader,
        BoxHeading,
        ProgressFooter
    }
})
export default class ReportForm extends Vue {
    @Action('fetchForm', { namespace: formNamespace }) fetchForm: any;
    @Action('updateUserAnswers', {namespace: formNamespace}) updateUserAnswers: any;
    @Getter('getForm', {  namespace: formNamespace }) getForm: any;
    @Getter('getAnswers', {  namespace: formNamespace }) getAnswers: any;
    @Getter('getGeneralInformationAnswers', {  namespace: formNamespace }) getGeneralInformationAnswers: any;
    @Mutation('toggleProgress', { namespace: progressNamespace }) toggleProgress: any;

    @Mutation('setStep1Active', {namespace: progressNamespace}) setStep1Active: any;
    @Mutation('setStep2Active', {namespace: progressNamespace}) setStep2Active: any;
    @Mutation('setStep3Active', {namespace: progressNamespace}) setStep3Active: any;

    selectedBranchID: string = '';
    userAnswers: object[] = [];
    userAnswersTemp: object[] = [];
    isLoading: boolean = true;
    form: any = {};

    created(): void {
        this.selectedBranchID = this.$route.params.id;

        this.fetchForm({branchId: this.$route.params.id, answers: this.getAnswers}).then((e) => {
            this.userAnswers = this.getAnswers;
            this.form = this.getForm;
            this.isLoading = false;
        });

        this.toggleProgress('reportForm');
        this.setStepsAllActive();
    }

    setStepsAllActive() {
        this.setStep1Active();
        this.setStep2Active();
        this.setStep3Active();
    }

    onInputChange(event:any, questID:string) {
        let answer = {
            questionId: questID,
            answerId: event.target.value
        };

        this.updateUserAnswers(answer);
    }

    onHandleSubmit() {
    }

    getAnswer(questionNumber:number):string {
        const aId = this.getAnswers[questionNumber-1]['answerId'];
        return aId;
    }
 };
